import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Button, IconButton } from '@mui/material';

interface HeaderProps {
  t: (key: string) => string;
  navigate: (path: string) => void;
  isEditMode?: boolean;
}

export const Header = ({ t, navigate, isEditMode = false }: HeaderProps) => (
  <div className="flex justify-between">
    <div className="flex items-center gap-2">
      <IconButton onClick={() => navigate('/settings/threat')}>
        <KeyboardArrowLeftIcon />
      </IconButton>
      <div>
        <div className="text-sm text-gray-500">
          {t('setting')} / {t('manage_threat')}
        </div>
        <div className="text-2xl font-medium">
          {isEditMode ? t('edit_threat') : t('create_threat')}
        </div>
      </div>
    </div>
    <Button type="submit" variant="contained" color="primary">
      {t('save')}
    </Button>
  </div>
);